import { render } from "./FloatingForm.vue?vue&type=template&id=3405bb1c&scoped=true"
import script from "./FloatingForm.vue?vue&type=script&lang=js"
export * from "./FloatingForm.vue?vue&type=script&lang=js"

import "./FloatingForm.vue?vue&type=style&index=0&id=3405bb1c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3405bb1c"]])

export default __exports__